import { Icon, theme, Tooltip } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 1px 3px;
  border-radius: 50%;
  background-color: white;
`;

export const TemplateWarningIcon = () => {
  const { t } = useTranslation(['templates']);
  return (
    <Container>
      <Tooltip title={t('unsupportedLanguageTooltip')}>
        <Icon icon="exclamation-triangle" color={theme.vars.newColor.gold2} />
      </Tooltip>
    </Container>
  );
};
